import { BehaviorParameters } from 'rangeConfig/@types';
import {
  QuestionSheetState,
  setQuestionSheetVisible,
  setQuestionSheetVisibleWithProps
} from 'ducks/questionSheet';
import billyIncludedShelf from '../images/billyIncludedShelf.png';
import { ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { HierarchyUtils } from '@inter-ikea-core/core';
import { setAcceptDeleteIncludedArticles } from 'ducks/sheets';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';

const replaceInterior = ({ rootState, coreApi, dispatch, props }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;

  const frame = HierarchyUtils.parent(selectedEntity);
  if (!frame) return;

  const frameDesign = frame.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.design;
  const selectedProduct = selectedEntity.getComponent<ProductInfoComponent>(
    ProductInfoComponent.id
  );

  const shelfDesign = selectedProduct?.design;

  if (frameDesign !== shelfDesign) {
    replaceProduct({ coreApi, rootState, dispatch, props });
    return;
  }

  const shelvesOnFrame = coreApi.entities.getChildrenWithProductType(
    frame,
    ProductType.BILLY_SHELF
  );

  const shelvesOnFrameOfDefaultDesign = shelvesOnFrame.filter(
    s => s.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.design === frameDesign
  );

  const numberOfShelves = coreApi.entities.getEntityComSize(frame)?.height === 2020 ? 4 : 2;

  const acceptedDeleteIncludedArticles = rootState.sheets.acceptedDeleteIncludedArticles;
  if (!acceptedDeleteIncludedArticles && shelvesOnFrameOfDefaultDesign?.length <= numberOfShelves) {
    dispatch(
      setQuestionSheetVisibleWithProps({
        modalVisible: true,
        title: 'storageone.removeIncludedShelfSheetTitle',
        preamble: 'storageone.removeIncludedShelfSheetBody',
        description: 'storageone.removeIncludedShelfSheetBody2',
        primaryButtonText: 'storageone.removeIncludedShelfSheetButtonPrimary',
        onAccept: () => {
          replaceProduct({ coreApi, rootState, dispatch, props });
          dispatch(setQuestionSheetVisible(false));
          dispatch(setAcceptDeleteIncludedArticles(true));
        },
        imageRealtivePath: billyIncludedShelf
      } as QuestionSheetState)
    );
  } else {
    replaceProduct({ coreApi, rootState, dispatch, props });
  }
};

export default replaceInterior;
